export default {
      id: "ellipsis-v-regular-usage",
      viewBox: "0 0 128 512",
      url: __webpack_public_path__ + "img/icons.792d8a78.svg#ellipsis-v-regular-usage",
      toString: function () {
        return this.url;
      }
    }